import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=6bd1648d&scoped=true&"
import script from "./CategoryTable.vue?vue&type=script&lang=ts&"
export * from "./CategoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=6bd1648d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1648d",
  null
  
)

export default component.exports